import { render, staticRenderFns } from "./rc-crm-organization-edit-dialog.vue?vue&type=template&id=4508ac84&scoped=true&"
import script from "./rc-crm-organization-edit-dialog.vue?vue&type=script&lang=js&"
export * from "./rc-crm-organization-edit-dialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4508ac84",
  null
  
)

export default component.exports